import { mapParamsBySchema } from '../../../util';
import { apiRequest } from '../../../Services/Common/ApiRequest';
import Global from '../../../Services/Common/Global';
import { M_DCM_BASIC_Schema } from './M_DCM_BASIC_Schema';
import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { handleQuerySuccess } from '../../../Hooks/apis/useQuriesSuccess';

/** 메뉴 조회 SP_GetMenu */
export const useSearch1 = (options = {}) => {
  const { onSuccess } = options;
  const params = mapParamsBySchema(M_DCM_BASIC_Schema.mapper.search1);

  const query = useQuery({
    queryKey: ['DocsManagement', 'getMenu', params],
    queryFn: () => apiRequest('post', Global.urls.Utility.getMenu, params),
    enabled: true,
  });

  useEffect(() => {
    if (!query.isSuccess) return;

    handleQuerySuccess(query.data, {
      onSuccess: async (rows) => {
        await onSuccess?.(rows);
      },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query.isSuccess, query.dataUpdatedAt]);

  return query;
};
